import { render, staticRenderFns } from "./FirmaComponent.vue?vue&type=template&id=5003a540&scoped=true"
import script from "./FirmaComponent.vue?vue&type=script&lang=js"
export * from "./FirmaComponent.vue?vue&type=script&lang=js"
import style0 from "./FirmaComponent.vue?vue&type=style&index=0&id=5003a540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003a540",
  null
  
)

export default component.exports